import { getSessionListApi } from '@api/robot';

const app = {
  state: {
    showConversationList: false,
    sessionList: [],
    hasAnswering: false
  },
  mutations: {
    addSessionList(state, val) {
      state.sessionList.unshift(val);
    },
    updateConversionListStatus(state, status) {
      state.showConversationList = status ?? !state.showConversationList;
    },

    closeStatus(state) {
      state.showConversationList = false;
    },
    setSessionList(state, val) {
      state.sessionList = val;
    },
    setHasAnswering(state, val) {
      state.hasAnswering = val;
    }
  },
  actions: {
    getSessionList({ commit }, data) {
      getSessionListApi(data).then(res => {
        commit('setSessionList', res);
      });
    },
    setHasAnswering({ commit }, val) {
      commit('setHasAnswering', val);
    }
  },
  getters: {
    showConversationList: state => state.showConversationList,
    sessionList: state => state.sessionList,
    hasAnswering: state => state.hasAnswering
  }
};

export default app;
